// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2sr53","vLegacy":"SelectSecondary_vLegacy__1t0A2","error":"SelectSecondary_error__1NJSJ","disabled":"SelectSecondary_disabled__1FWfY"};